
import Vue, { PropType } from 'vue'

export interface Item extends Record<string, unknown> {
  key: string | number,
  value: string,
  isActive?: boolean,
  showAppendIcon?: boolean
}

export default Vue.extend({
  name: 'customSelectComponent',
  props: {
    value: {
      type: String as PropType<string>,
      required: true
    },
    additionalValue: {
      type: String as PropType<string>
    },
    list: {
      type: Array as PropType<Item[]>,
      required: true
    },
    search: {
      type: Boolean as PropType<boolean>,
      default: false
    },
    align: {
      type: String as PropType<string>,
      default: 'left'
    },
    appendStatusIcon: {
      type: Boolean as PropType<boolean>,
      default: false
    }
  },
  data: () => ({
    opened: false,
    searchPhrase: '',
    isClickBySearch: false
  }),
  watch: {
    opened (value: boolean) {
      this.$emit('toggle', value)
    }
  },
  computed: {
    filtredList () {
      const vm = this as any
      if (!vm.searchPhrase) return vm.list
      return vm.list.filter((item: Item) => {
        return item.value.toLowerCase().includes(vm.searchPhrase.toLowerCase())
      })
    }
  },
  methods: {
    handleClick (item: Item): void {
      const vm = this as any
      vm.opened = false
      vm.$emit('input', item)
    },
    handleClickOutside (event: any): void {
      event.preventDefault()
      const vm = this as any
      const searchField = vm.$refs
      let isSearchField = false
      for (const currentEl of event.path) {
        if (currentEl === searchField.$el) isSearchField = true
      }
      if (vm.opened && !isSearchField) vm.opened = false
    }
  }
})
